import { Component, ElementRef, inject, output, viewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '../service/layout.service';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { RippleModule } from 'primeng/ripple';
import { SubnavComponent } from '../../../../components/subnav/subnav.component';
import { NoticeCenterService } from '../../../../services/data/noticecenter.service';

@Component({
    selector: '[app-topbar]',
    standalone: true,
    imports: [RouterModule, SubnavComponent, CommonModule, StyleClassModule, InputTextModule, ButtonModule, IconFieldModule, InputIconModule, RippleModule],
    template: `<div
        class="layout-topbar"
        [ngClass]="{
            'border-bottom-none': layoutService.layoutConfig().topbarTheme !== 'light'
        }"
    >
        <div class="layout-topbar-start">
            <a class="layout-topbar-logo" href="/">
                <img src="assets/images/PG_Logo_2022_Horizontal_Y&W.png" alt="Logo" style="height: 35px;" />
            </a>
            <a #menuButton class="layout-menu-button" (click)="onMenuButtonClick()" pRipple>
                <i class="pi pi-bars"></i>
            </a>
        </div>

        <div class="layout-topbar-end">
            <subnav class="d-none d-xl-inline w-100" (toggleNotificationSidebar)="onToggleNotification($event)"/>
        </div>
        <subnav class="d-xl-none w-100" (toggleNotificationSidebar)="onToggleNotification($event)"/>
    </div>`
})
export class AppTopbar {
    private noticeCenterService: NoticeCenterService = inject(NoticeCenterService);

    readonly menuButton = viewChild.required<ElementRef>('menuButton');

    readonly mobileMenuButton = viewChild.required<ElementRef>('mobileMenuButton');

    readonly toggleNotificationSidebar = output<boolean>();

    constructor(public el: ElementRef) {}

    activeItem!: number;

    layoutService: LayoutService = inject(LayoutService);

    get mobileTopbarActive(): boolean {
        return this.layoutService.layoutState().topbarMenuActive;
    }
    
    ngOnInit(): void {
        this.noticeCenterService.startUnreadMessagesTimer();
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onMobileTopbarMenuButtonClick() {
        this.layoutService.onTopbarMenuToggle();
    }

    onConfigSidebarToggle() {
        this.layoutService.showConfigSidebar();
    }

     onToggleNotification(visible: boolean) {
        this.toggleNotificationSidebar.emit(visible);
    }
}